module.exports = __webpack_public_path__ + "img/credit-one-club-gal-11.20a28c09.jpg";